// @givmo/app-admin — Employees → Roster: the "occasion routes are dark here" notice (EP-WEB11).
//
// Deliberately NOT an error surface. The backend's `COMPANY_OCCASION_PROGRAMS_ENABLED` flips
// independently of this build's `VITE_COMPANY_OCCASION_PROGRAMS_ENABLED`, so an admin can reach a
// visible occasion affordance whose route 404s — a normal skew during a promotion round, not a
// rejected entry and not a broken file. It reads as information (neutral surface, no danger tone,
// no retry) because there is nothing the admin can do about it and nothing of theirs went wrong.

import type { ReactNode } from 'react';
import { Icon } from '@givmo/design-system';
import { Info } from 'lucide-react';

export function OccasionUnavailableNotice({
  children,
  testId,
}: {
  children: ReactNode;
  testId: string;
}) {
  return (
    <div
      className="flex items-start gap-10 rounded-lg border border-border-subtle bg-surface-sunken p-12"
      data-testid={testId}
    >
      <span className="mt-1 shrink-0 text-text-tertiary">
        <Icon icon={Info} size={16} aria-hidden />
      </span>
      <p className="font-sans text-s13 leading-h15 tracking-normal text-text-secondary">
        {children}
      </p>
    </div>
  );
}
